module.exports = __webpack_public_path__ + "static/img/GI.d8a9d3c4.png";